export default __webpack_public_path__ + "353458e4c7ef5e22df86c115565ae175.png";